// removed by extract-text-webpack-plugin
module.exports = {"html":"StrongholdExternal_html--2obGd","body":"StrongholdExternal_body--3GorQ","base":"StrongholdExternal_base--13wAF"};


//////////////////
// WEBPACK FOOTER
// ./containers/StrongholdExternal/StrongholdExternal.scss
// module id = 3859
// module chunks = 13